import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface AssignMissionParams {
  transportJobId: string;
  driverId: string;
  vehicleId: string;
}

export const useAssignMission = () => {
  const queryClient = useQueryClient();

  const assignMutation = useMutation({
    mutationFn: async ({ transportJobId, driverId, vehicleId }: AssignMissionParams) => {
      const { data, error } = await supabase
        .from('transport_jobs')
        .update({
          driver_id: driverId,
          vehicle_id: vehicleId,
        })
        .eq('id', transportJobId)
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transport-jobs'] });
      queryClient.invalidateQueries({ queryKey: ['drivers'] });
      queryClient.invalidateQueries({ queryKey: ['vehicles'] });
    },
  });

  return {
    assignMission: assignMutation.mutateAsync,
    isAssigning: assignMutation.isPending,
  };
};
